<template>
  <div id="elevator_fix">
    <ul class="elevator_box">
      <li>
        <a href="javascript:;" class="current">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">精品推荐</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">限时特惠</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">采购套餐</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">当季热销</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">热销设计</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">热销名片</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">常用设计</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">宣传物料</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">喷绘用品</span>
        </a>
      </li>
      <li>
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <span class="elevator_txt">猜你喜欢</span>
        </a>
      </li>
      <li class="floor_items_last">
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <i class="icon_kf"></i>
          <span class="elevator_txt">客服</span>
        </a>
      </li>
      <li class="floor_items_last">
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <i class="icon_fk"></i>
          <span class="elevator_txt">反馈</span>
        </a>
      </li>
      <li class="floor_items_last return_top">
        <a href="javascript:;">
          <span class="elevator_bg"></span>
          <i class="icon_db"></i>
          <span class="elevator_txt">顶部</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(_ => {
      $(window).on('scroll', function() {
        var $scroll = $(this).scrollTop()
        if ($scroll >= 600) {
          $('#elevator_fix')
            .stop()
            .fadeIn()
        } else {
          $('#elevator_fix')
            .stop()
            .fadeOut()
        }
        if ($('.floor')) {
          $('.floor').each(function() {
            var $floortop =
              $('.floor')
                .eq($(this).index())
                .offset().top + 250
            if ($floortop > $scroll) {
              $('#elevator_fix .elevator_box li')
                .children('a')
                .removeClass('current')
              $('#elevator_fix .elevator_box li')
                .eq($(this).index())
                .children('a')
                .addClass('current')
              return false
            }
          })
        }
      })
    })
    var $loutili = $('#elevator_fix .elevator_box li').not('.floor_items_last')
    $loutili.on('click', function() {
      $(this)
        .children('a')
        .addClass('current')
        .siblings('li')
        .children('a')
        .removeClass('current')
      var $loutitop = $('.floor')
        .eq($(this).index())
        .offset().top
      $('html,body').animate({
        scrollTop: $loutitop - 60
      })
    })
    $('.return_top').on('click', function() {
      $('html,body').animate({
        scrollTop: 0
      })
    })
  }
}
</script>

<style lang="less" scoped>
#elevator_fix {
  display: none;
  position: fixed;
  top: 130px;
  right: 50%;
  margin-right: -685px;
  width: 50px;
  height: 660px;
  background: #fff;
  ul {
    width: 100%;
    height: 100%;
    .return_top {
      background-color: #fff;
    }
    li {
      width: 50px;
      height: 50px;
      border-bottom: 2px solid #ddd;
      a {
        position: relative;
        box-sizing: border-box;
        display: block;
        width: 100%;
        height: 100%;
        padding: 10px;
        color: #666;
        transition: all 0.2s ease;
        i {
          display: block;
          width: 16px;
          height: 16px;
          margin-left: 6px;
        }
        .icon_kf {
          background: url('../../assets/index/staris/kf.png') no-repeat center;
        }
        .icon_fk {
          background: url('../../assets/index/staris/fk.png') no-repeat center;
        }
        .icon_db {
          background: url('../../assets/index/staris/db.png') no-repeat center;
        }
        .return_top:hover .icon_db {
          background: url('../../assets/index/staris/db-curr.png') no-repeat
            center;
        }
      }
      a:hover {
        background: #a77c5a;
        color: #fff;
      }
      .elevator_txt {
        z-index: 3;
        font-size: 12px;
        letter-spacing: 3px;
      }
    }
  }
  .current {
    background: #a77c5a;
    color: #fff;
  }
}
</style>
